import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as typeformEmbed from '@typeform/embed';
import { Redirect } from 'react-router-dom';
import { Container, Segment, Header } from 'semantic-ui-react';

import SharingButtons from 'components/SharingButtons/index';
import { onSurveySubmit, onDone } from '../actions';
import '../style.css';

class ConfirmationPage extends Component {
  componentDidMount() {
    const { email, onSurveySubmit } = this.props;
    this.typeformEl &&
      typeformEmbed.makeWidget(
        this.typeformEl,
        `https://admin.typeform.com/to/B0S09r?email=${email}`,
        {
          opacity: 0,
          hideScrollbars: true,
          onSubmit: () => { onSurveySubmit(email) },
          buttonText: 'Take the survey!',
          hideHeaders: true,
          hideFooter: true
        }
      )
  }

  componentWillUnmount() {
    this.props.onDone();
  }

  renderThankYou = () => {
    const { duplicateEntry } = this.props;
    const header = duplicateEntry
      ? "Looks like you've already signed up and completed our survey. Thank you so much!"
      : "Thank you so much! We'll be in touch soon."
    return (
      <Container className='thankyou-message'>
        <Segment textAlign='center' vertical>
          <Header> { header } </Header>
          { duplicateEntry &&
            <p className='note'>
              If you have any questions, feel free to reach out at
              <a href={`mailto:contact@winno.io`}> contact@winno.io</a>.
            </p>
          }
          <p className='note'>
            In the meantime, share <b>winno</b> with your friends and coworkers...
          </p>
          <SharingButtons url={'https://winno.io'} />
        </Segment>
      </Container>
    )
  }

  renderTypeForm = () => {
    return (
      <div
        ref={el => this.typeformEl = el}
        className="typeform-widget">
      </div>
    )
  }

  render() {
    const { surveyCompleted, email } = this.props;
    // ensure there is an email to use, if not redirect
    if ((!email || email.length < 0) && !surveyCompleted) return <Redirect to='/'/>
    return (
      <div className='confirmation-page'>
        {
          surveyCompleted
            ? this.renderThankYou()
            : this.renderTypeForm()
        }
      </div>
    );
  }
}

const mapStateToProps = ({ scene }) => {
  return {
    email: scene.landingFlow.email,
    surveyCompleted: scene.landingFlow.surveyCompleted,
    duplicateEntry: scene.landingFlow.duplicateEntry
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSurveySubmit: (email) => {
      dispatch(onSurveySubmit(email))
    },
    onDone: () => { dispatch(onDone()) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPage);



// WEBPACK FOOTER //
// ./src/scenes/LandingFlow/components/ConfirmationPage.js